import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { InstitutionsListBox } from "@/features/institutions/components/institutions-list-box";
import { InstitutionsType } from "@/shared/config/globals"
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";


interface Props {
  onSelectInstitution: () => void;
  onTapCloseModal: () => void;
}

// 金融機関選択モーダル
export const SelectInstitutionsModal = (props: Props) => {
  const {
    onSelectInstitution,
    onTapCloseModal,
  } = props;

  const {
    institutionType,
  } = useInstitutionsContext();

  const institutionTypeName = (() => {
    let name = "";
    switch (institutionType) {
      case InstitutionsType.Bank:
        name = "銀行";
        break;
      case InstitutionsType.Card:
        name = "クレジットカード";
        break;
      case InstitutionsType.ElectronicMoney:
        name = "電子マネー";
        break;
      case InstitutionsType.Other:
        name = "他サービス連携";
        break;
    }
    return name;
  })();

  return (
    <BasePageModal
      title={`${institutionTypeName}用Web明細帳を作成`}
      handleClose={() => {
        onTapCloseModal();
      }}
      className={`md-select-bank ${institutionType}`}
      disableOverlayClose={true}
    >
      <h2>
        金融機関の頭文字を選択する
      </h2>
      <InstitutionsListBox
        onSelectInstitution={onSelectInstitution}
      />
    </BasePageModal>
  );
};